import React from 'react'
import { useTranslation } from 'react-i18next'
import {
	checkIsMobile,
	getCurrency,
	getLanguageLocale,
	stringifyNum,
} from 'shared'
import { SeeAll, Select } from 'selfServicePortal/components/index'
import { useTransactions } from 'selfServicePortal/hooks/useTransactions'

interface IMobileTransactions {
	isOverview: boolean
}
const MobileTransactions = ({ isOverview }: IMobileTransactions) => {
	const { t } = useTranslation()
	const isMobile = checkIsMobile()
	const { getMoreTransactionsFromMonth, tableData, hideShowMore } =
		useTransactions()

	let containerCls = ['transactions', 'my-5']
	if (isMobile && !isOverview) containerCls.push('container')

	return (
		<div className={containerCls.join(' ')}>
			<div className="d-flex justify-content-between mb-3">
				<div>{t('LastTransactions')}</div>
				{isOverview ? (
					<SeeAll
						isOverview={isOverview}
						showMore={() =>
							getMoreTransactionsFromMonth(
								tableData[0]?.transactionDate!,
								tableData.length + 10
							)
						}
						hideShowMore={hideShowMore}
					/>
				) : (
					<Select
						getMoreTransactionsFromMonth={
							getMoreTransactionsFromMonth
						}
					/>
				)}
			</div>
			{tableData?.map((item: any, key: any) => {
				return (
					<div
						key={key}
						className="mobile-item d-flex flex-column py-3">
						<div>
							{new Date(item.transactionDate).toLocaleDateString(
								getLanguageLocale()
							)}
						</div>
						<div className="d-flex justify-content-between">
							<div>{item.transactionTypeUiString}</div>
							<div>
								{stringifyNum(item.amount, {
									currency: getCurrency(),
									style: 'currency',
								})}
							</div>
						</div>
					</div>
				)
			})}
		</div>
	)
}

export default MobileTransactions
